import MuiSelect, { SelectProps } from '@mui/material/Select';
import { FC } from 'react';
import ArrowDownIcon from 'components/Icons/ArrowDownIcon';

const Select: FC<SelectProps> = (props) => (
  <MuiSelect { ...props } IconComponent={ ArrowDownIcon } />
);

export default Select;
